import { SoundOffSmall, SoundSmall } from "@wix/wix-ui-icons-common";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { Slider, SLIDER_TRACK_SIZE } from "./../../ui-components/index.js";
import classes from "../statics/styles/sound-control.rtlignore-scss.js";
import { AUDIO_VOLUME_SLIDER } from "./data-hooks.js";
import { IconButton } from "./icon-button.js";
const SoundControl = ({
  volume,
  muted,
  handleMute,
  handleVolumeChange,
  disabled
}) => {
  const { t, tabIndex } = useContext(RicosContext);
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      handleMute();
      return;
    }
  };
  const SoundIconComponent = muted ? SoundOffSmall : SoundSmall;
  return /* @__PURE__ */ React.createElement("div", { className: classNames(classes.root) }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onKeyDown,
      "aria-label": muted ? t("Audio_Plugin_Volume_Control_Unmute_AriaLabel") : t("Audio_Plugin_Volume_Control_Mute_AriaLabel"),
      tabIndex,
      isLoading: disabled
    },
    /* @__PURE__ */ React.createElement(SoundIconComponent, { onClick: handleMute })
  ), /* @__PURE__ */ React.createElement("div", { className: classNames(classes.sliderContainer) }, /* @__PURE__ */ React.createElement(
    Slider,
    {
      min: 0,
      max: 1,
      step: "0.1",
      value: volume,
      onChange: handleVolumeChange,
      onChangeCommitted: handleVolumeChange,
      languageDir: "ltr",
      dataHook: AUDIO_VOLUME_SLIDER,
      trackSize: SLIDER_TRACK_SIZE.small,
      tabIndex,
      ariaLabel: t("Audio_Plugin_Volume_Control_Slider_AriaLabel"),
      className: "has-custom-focus"
    }
  )));
};
var SoundControl_default = SoundControl;
export {
  SoundControl_default as default
};
//# sourceMappingURL=SoundControl.js.map
